<template>
  <v-dialog v-bind="$attrs" class="e-dialog" :transition="transitionValue">
    <template v-for="(_, slot) in $slots" #[slot]="scope">
      <slot :name="slot" v-bind="scope || {}" />
    </template>
  </v-dialog>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useDisplay } from 'vuetify'
import { VDialog } from 'vuetify/components/VDialog'

const { mobile } = useDisplay()

const props = defineProps({
  transition: {
    type: [String, Object],
    default: '',
  },
})

const transitionValue = ref('dialog-transition')

watch(
  mobile,
  () => {
    transitionValue.value = mobile.value ? 'dialog-bottom-transition' : 'dialog-transition'
  },
  { immediate: true }
)
</script>

<style lang="scss">
@import '../../scss/styles';
@import 'vuetify/lib/styles/settings/variables';

// EDialog
.e-dialog {
  .v-overlay__scrim {
    background: rgba(22, 23, 24, 0.6);
    opacity: 1;
  }
}

// .v-theme--dark {
//   &.e-dialog {
//     .v-overlay__scrim {
//       background: rgba(22, 23, 24, 0.6);
//       opacity: 1;
//     }
//   }
// }

@media #{map-get($display-breakpoints, 'xs')} {
  .e-dialog {
    &.v-dialog {
      >.v-overlay__content {
        width: 100% !important;
        max-width: 100% !important;
        margin: 0;
        bottom: 0;
      }
    }
  }
}
</style>
